import { Localization } from "@viamap/viamap2-common";
import { ADModalBody, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { ManagedWindow } from "src/WindowManager/WindowState";

export function DataRapportInfo(props: { managedWindow?: ManagedWindow, onClose: () => void }) {

   return (
      <AdvancedDragModal
         PosDefault={{ left: "150px", top: "150px", width: "400px" }}
         variant={"Small"} onClose={props.onClose} title={Localization.getText("Data report info")}>
         <ADModalInfo >
            <div style={{ fontSize: "14px", lineHeight: "20px", textAlign: "left" }}>
               {Localization.getLanguage() == "da" ?
                  "Datarapporten generer rapporter baseret på ejendomslag. Ejendomslag kan oprettes igennem med forskellige funktioner i Mapit.\n\nF.eks. fra;\n  Discover: 'S' og 'M'\n  Explore: 'Tilføj som SFE kortlag'\n  Personinfo: 'Tilføj som SFE kortlag' \n  Ejerskab: 'Tilføj som SFE kortlag'\n  Excel Import: 'Områder ud fra SFEnummer'\n  Samt søgning på SFEnr." :
                  "The data report generates reports based on property layers. These can be created through various functions in Mapit.\n\nFor example from;\n  Discover: 'S' and 'M'\n  Explore: 'Add as SFE layer'\n  Personinfo: 'Add as SFE layer' \n  Ownership: 'Add as SFE layer'\n  Excel Import: 'Areas from SFE Number'\n  As well as searching for SFE number."
               }
            </div>

         </ADModalInfo>
         <ADModalBody>
            <div />
         </ADModalBody>
      </AdvancedDragModal>
   );
}
